import AllTopicsButton from './AllTopicsButton';

export default AllTopicsButton;
